import { TagRequest } from '@tiendanube/common';

// TODO: optimize this function
export const generateTagsPayload = (
  originalTags: string[],
  newTags: string[],
): TagRequest[] => {
  const tagsToCreate: TagRequest[] = [];
  const tagsToDelete: TagRequest[] = [];

  originalTags.forEach((tag) => {
    if (!newTags.includes(tag)) {
      tagsToDelete.push({ tag, '@delete': true });
    }
  });

  newTags.forEach((tag) => {
    if (!originalTags.includes(tag)) {
      tagsToCreate.push({ tag });
    }
  });

  return [...tagsToCreate, ...tagsToDelete];
};
